export default __webpack_public_path__ + "static/media/icon-1.04cbc68c.svg";